import React from "react";
import "./BackIcon.css";
import ArrowLeftDark from "../../assets/icons/ArrowLeftDark.svg";
import ArrowLeftLight from "../../assets/icons/ArrowLeftLight.svg";

const BackIcon = ({ colors, isDarkMode, onPress }) => {
  return (
    <div
      className="back-icon-container"
      style={{ backgroundColor: colors.background }}
      onClick={onPress}
    >
      <img
        className="back-icon"
        alt="Arrow"
        src={isDarkMode ? ArrowLeftDark : ArrowLeftLight}
        draggable={false}
      />
    </div>
  );
};
export default BackIcon;
